import React from 'react';
import LoginPage from '../components/login';

const Login = () => {
    return (
      <div>
        <LoginPage/>
      </div>
    );
  };
  
  export default Login;